import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgBellActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} width={48} height={48} rx={24} fill="#fff" />
    <path
      d="M12.701 25.043c-.46 1.534 3.287 4.191 7.612 5.944.842.341 1.706.648 2.565.906 1.211.363 2.505.656 3.787.87 4.297.716 8.453.54 8.877-.87.706-2.356-3.651-2.704-2.665-8.84.986-6.134-.47-9.739-3.902-10.768-3.432-1.03-6.404 1.498-9.31 6.806-2.907 5.308-6.257 3.596-6.964 5.952Z"
      fill="url(#bell-active_svg__a)"
    />
    <path
      d="M26.023 36.06c-.614 1.244-1.859 2.008-3.266 2.015-2.182.01-3.967-1.969-3.738-4.05 1.74.838 4.585 1.827 7.005 2.035Z"
      fill="url(#bell-active_svg__b)"
    />
    <path
      d="M28.975 12.285c-3.432-1.03-6.404 1.498-9.31 6.806-2.907 5.308-6.257 3.596-6.964 5.952-.46 1.534 3.287 4.191 7.612 5.944.842.341 1.706.648 2.565.906 1.211.363 2.505.656 3.787.87 4.297.716 8.453.54 8.877-.87.706-2.356-3.651-2.704-2.665-8.84.986-6.134-.47-9.739-3.902-10.768Zm0 0 .767-2.616m-6.985 28.406c1.407-.007 2.652-.77 3.266-2.015-2.419-.208-5.263-1.197-7.004-2.035-.229 2.081 1.556 4.06 3.738 4.05Z"
      stroke="url(#bell-active_svg__c)"
    />
    <defs>
      <linearGradient
        id="bell-active_svg__a"
        x1={24.141}
        y1={38.075}
        x2={24.141}
        y2={9.669}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#27E4D6" />
        <stop offset={0.178} stopColor="#15C1C6" />
        <stop offset={0.371} stopColor="#2E90EA" />
        <stop offset={0.574} stopColor="#776CF2" />
        <stop offset={0.798} stopColor="#995EE3" />
        <stop offset={1} stopColor="#CB47D1" />
      </linearGradient>
      <linearGradient
        id="bell-active_svg__b"
        x1={24.141}
        y1={38.075}
        x2={24.141}
        y2={9.669}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#27E4D6" />
        <stop offset={0.178} stopColor="#15C1C6" />
        <stop offset={0.371} stopColor="#2E90EA" />
        <stop offset={0.574} stopColor="#776CF2" />
        <stop offset={0.798} stopColor="#995EE3" />
        <stop offset={1} stopColor="#CB47D1" />
      </linearGradient>
      <linearGradient
        id="bell-active_svg__c"
        x1={24.141}
        y1={38.075}
        x2={24.141}
        y2={9.669}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#27E4D6" />
        <stop offset={0.178} stopColor="#15C1C6" />
        <stop offset={0.371} stopColor="#2E90EA" />
        <stop offset={0.574} stopColor="#776CF2" />
        <stop offset={0.798} stopColor="#995EE3" />
        <stop offset={1} stopColor="#CB47D1" />
      </linearGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgBellActive);
export default Memo;
